import { ISearchType } from '@search/offer-search-routes/src/searchRoute';
import { Filters, IFilter } from '../../models/Filter';
import { filterDeserializers } from './FilterDeserializer';
import { filterSerializers } from './FilterSerializer';

// @deprecated Use routing parsing instead
export const filterCodec2 = {
    serialize: (
        filters: Map<Filters, IFilter>,
        filtersToCodec: Filters[]
    ): ISearchType => {
        const result = {} as ISearchType;

        for (const filterName of filtersToCodec) {
            const filter = filters.get(filterName);
            const serializer = filterSerializers[filterName];
            const value = serializer(filter);

            if (Array.isArray(value)) {
                // @ts-ignore
                result[Filters[filterName]] = value;
            } else if (typeof value === 'object') {
                Object.assign(result, value);
            } else {
                // @ts-ignore
                result[Filters[filterName]] = value;
            }
        }

        return result;
    },
    deserialize: (parsedQuery: ISearchType): Map<Filters, IFilter> => {
        const result: Map<Filters, IFilter> = new Map<Filters, IFilter>();

        (Object.keys(filterDeserializers) as Filters[]).forEach(filter => {
            const keys = filterDeserializers[filter].keys;
            const data = {} as ISearchType;

            for (const key of keys) {
                const parsedObject = parsedQuery[key];

                if (parsedObject) {
                    data[key] = parsedObject;
                }
            }

            result.set(filter, filterDeserializers[filter].handler(data));
        });

        return result;
    }
};
